import { useTranslation } from 'next-i18next';

import { QuickFiltersItem } from './QuickFiltersItem';

/**
 * @typedef {{ id: string; label: string }} QuickFiltersItem
 */

/**
 * @param {{
 *   items: QuickFiltersItem[];
 *   value: string | null;
 *   onChange: (tag: string | null) => void;
 * }} props
 *
 * @return {JSX.Element}
 */
export function QuickFilters({ items, value, onChange }) {
  const { t: tt } = useTranslation('data_characters_tags');
  const { t: tGirlsTags } = useTranslation('data_characters_tags');

  return (
    <div className="flex flex-row items-center gap-[10px] flex-wrap">
      <QuickFiltersItem active={!value} onClick={() => onChange(null)}>
        {tt('all')}
      </QuickFiltersItem>

      {items.map((item) => (
        <QuickFiltersItem
          key={item.id}
          active={item.id === value}
          onClick={() => onChange(item.id)}
        >
          {tGirlsTags(item.label)}
        </QuickFiltersItem>
      ))}
    </div>
  );
}
